/**
 * The saved mark: a bookmark, filled when the night is on your list.
 *
 * It was a heart, on five surfaces, and a heart says the wrong thing. Saving a night is
 * filing it — "I want this where I can find it" — and not liking it. A gig you save because
 * a friend is going, or because you are undecided, is not one you have an opinion about, and
 * the heart was asking for one every time.
 *
 * One component, and that is the other half of the change. The heart was drawn out four
 * times — `Marks`, the month chip, the list row and the briefing — with the same path, the
 * same `strokeLinejoin`, and the same comment about why it is drawn rather than typed
 * written three times over. Swapping four copies of a heart for four copies of a bookmark
 * would have been the same mistake with a better symbol.
 *
 * Drawn, not typed. `♥` is a text glyph: at the 10px these sit at in a month cell the font
 * hints it into a wedge, and which wedge depends on the platform's emoji font. A path is the
 * same shape at every size and on every machine. That argument was already written down in
 * three of the four files; it only ever needed to be true in one.
 *
 * The star stays on artists. Following an act and saving a night are different promises and
 * the two symbols say so; whether the heart eventually moves to artists in the star's place
 * is a decision that was deliberately left for later.
 */
export function Bookmark({
  fill,
  className,
  size = 15,
  strokeWidth = 2,
}: {
  fill: boolean
  className?: string
  /** Both dimensions — the glyph is square, like the tick and the star beside it. */
  size?: number
  /** Heavier in a month cell than on a card, because a 10px stroke at 1.7 disappears. */
  strokeWidth?: number
}) {
  return (
    <svg
      {...(className ? { className } : {})}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* A ribbon with a notch out of the foot. Squared rather than rounded at the shoulders:
          the tick and the star next to it are both angular, and a rounded bookmark reads as a
          different family of icon. */}
      <path d="M6 3.5h12v17l-6-4.2-6 4.2z" />
    </svg>
  )
}
